import { createAsyncThunk } from "@reduxjs/toolkit";

import { type Product } from "@fitness-app/data-models/entities/Product";
import { getErrorMessage } from "@fitness-app/utils";

import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCT_REDUCER_NAME } from "../types";

type Payload = {
  productId: string;
  enabledPaymentGateways: Product["enabledPaymentGateways"];
  paymentsMethods?: Product["paymentsMethods"];
};

export const updateProductPaymentGateways = createAsyncThunk<
  void,
  ActionParams<Payload>,
  AsyncThunkCreator<number | string>
>(
  `${PRODUCT_REDUCER_NAME}/updateProductPaymentGateways`,
  async ({ payload, onSuccess, onFailure }, { rejectWithValue, extra: { db, analytics } }) => {
    try {
      await db
        .from("product")
        .update({
          enabledPaymentGateways: payload.enabledPaymentGateways,
          ...(payload.paymentsMethods !== undefined ? { paymentsMethods: payload.paymentsMethods } : {}),
        })
        .eq("id", payload.productId);

      analytics.track("update_product_payment_gateways", {
        enabledPaymentGateways: payload.enabledPaymentGateways?.join(", "),
      });
      onSuccess?.();
    } catch (e) {
      onFailure?.();

      return rejectWithValue(getErrorMessage(e));
    }
  },
);
